import * as utils from "../common/utils";

class SecureModel {
  /**
   * @returns {string}
   */
  getAccessToken() {
    return utils.getCookie("access_token") || "";
  }

  /**
   * @param {string} accessToken
   */
  setAccessToken(accessToken) {
    if (accessToken === "") {
      utils.setCookie("access_token", accessToken, 0);
    } else {
      utils.setCookie("access_token", accessToken, 360);
    }
  }

  /**
   * @returns {string}
   */
  getRefreshToken() {
    return utils.getCookie("refresh_token") || "";
  }

  /**
   * @param {string} refreshToken
   */
  setRefreshToken(refreshToken) {
    if (refreshToken === "") {
      utils.setCookie("refresh_token", refreshToken, 0);
    } else {
      utils.setCookie("refresh_token", refreshToken, 360);
    }
  }

  /**
   * @param {object} secureData
   */
  setSecureData(secureData) {
    if (secureData.accessToken) {
      this.setAccessToken(secureData.accessToken);
    } else {
      this.setAccessToken("");
    }
    if (secureData.refreshToken) {
      this.setRefreshToken(secureData.refreshToken);
    } else {
      this.setRefreshToken("");
    }
  }
}

export default SecureModel;
